/**
 *  @class
 *  @function ModalDialog
 */
if (!customElements.get('modal-dialog')) {
  class ModalDialog extends HTMLElement {
    constructor() {
      super();

      this.age_verification = this.classList.contains('age-verification-modal');
      this.id = this.getAttribute('id');
      this.delay = parseInt(this.dataset.delay, 10) * 1000;
      this.popup = this.dataset.popup;
      this.section_id = this.dataset.sectionId;
      this.disabled = this.getAttribute('disabled') != undefined;
      this.button = this.querySelector('[id^="ModalClose-"]') || this.querySelector('.product-media-modal__toggle');

      if (this.button) {
        this.button.addEventListener('click', this.hide.bind(this));
      }

      if (!this.disabled) {
        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') {
            this.hide();
          }
        });
        this.addEventListener('click', (event) => {
          // 支持 modal-dialog 和 product-modal
          if (event.target.nodeName === 'MODAL-DIALOG' || event.target.nodeName === 'PRODUCT-MODAL') {
            this.hide();
          }
        });
      }
      if (this.delay && this.delay > 0) {
        if (!this.getCookie()) {
          setTimeout(() => {
            this.show();
            this.button.addEventListener('click', this.setCookie.bind(this));
          }, this.delay);
        }
      }
      if (this.age_verification) {
        if (!this.getCookie()) {
          this.show();
        }
        this.button.addEventListener('click', this.setCookie.bind(this));
      }
      if (Shopify.designMode) {
        this.moved = true;
        document.addEventListener('shopify:section:select', (event) => {
          if (event.detail.sectionId === this.section_id) {
            this.show();
          }
        });
        document.addEventListener('shopify:section:deselect', (event) => {
          if (event.detail.sectionId === this.section_id) {
            this.hide();
          }
        });
      }
    }

    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      // 延迟移动到 body，确保 DOM 完全加载
      if (document.body) {
        document.body.appendChild(this);
      } else {
        // 如果 body 还没准备好，等待 DOMContentLoaded
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => {
            if (!this.moved || this.parentNode !== document.body) {
              document.body.appendChild(this);
            }
          });
        } else {
          document.body.appendChild(this);
        }
      }
    }

    show(opener) {
      this.openedBy = opener;
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');

      setTimeout(() => {
        const dialog = this.querySelector('[role="dialog"]');
        if (dialog) {
          dialog.focus();
        }
      }, 100);
    }

    hide() {
      document.body.classList.remove('overflow-hidden');
      this.removeAttribute('open');
      this.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
      });
      this.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
      });
      this.querySelectorAll('video').forEach((video) => video.pause());

      if (this.popup) {

      }
    }

    getCookie() {
      return window.localStorage.getItem(this.id);
    }
    setCookie() {
      window.localStorage.setItem(this.id, JSON.stringify(new Date()));
    }
  }
  customElements.define('modal-dialog', ModalDialog);
  // 将 ModalDialog 类暴露为全局变量，供其他脚本使用
  window.ModalDialog = ModalDialog;
}
if (!customElements.get('modal-opener')) {
  class ModalOpener extends HTMLElement {
    constructor() {
      super();
      this._boundClickHandler = null;
    }

    connectedCallback() {
      // 防止重复绑定
      if (this._boundClickHandler) return;
      
      const button = this.querySelector('button');
      if (!button) return;
      
      const modalSelector = this.getAttribute('data-modal');
      if (!modalSelector) return;
      
      this._boundClickHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        // 尝试查找弹窗
        let modal = document.querySelector(modalSelector);
        
        // 如果找不到，尝试在整个文档中查找（可能在 section 中）
        if (!modal) {
          const id = modalSelector.replace('#', '');
          modal = document.getElementById(id);
        }
        
        if (modal) {
          // 确保弹窗已经移动到 body（如果还没有）
          if (modal.parentNode !== document.body) {
            document.body.appendChild(modal);
          }
          
          // 确保弹窗已经初始化
          if (modal.moved !== true && modal.connectedCallback) {
            modal.connectedCallback();
          }
          
          if (typeof modal.show === 'function') {
            modal.show(button);
          }
        }
      };
      
      button.addEventListener('click', this._boundClickHandler);
    }

    disconnectedCallback() {
      const button = this.querySelector('button');
      if (button && this._boundClickHandler) {
        button.removeEventListener('click', this._boundClickHandler);
        this._boundClickHandler = null;
      }
    }
  }
  customElements.define('modal-opener', ModalOpener);
}